export default __webpack_public_path__ + "static/media/SA_Accepted.918402d3.png";